import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const instrumentSelection = {
    name: "Instrument Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose instrument(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Instrument",
    },
    type: "input",
    category: "dashboard",
};
